module.exports = __webpack_public_path__ + "img/loupe.ac811b2c.svg";